import { ReactElement, ReactNode } from 'react';
import { ConfigProvider } from 'antd';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import CssBaseline from './CssBaseline';
import themeConfig from './theme-config';

interface ThemeProviderProps {
  children: ReactNode;
}

const ThemeProvider = ({ children }: ThemeProviderProps): ReactElement => {
  return (
    <ConfigProvider theme={themeConfig}>
      <StyledThemeProvider theme={themeConfig.token}>
        {children}
        <CssBaseline />
      </StyledThemeProvider>
    </ConfigProvider>
  );
};

export default ThemeProvider;
